import UserDto from "../accountmodule/UserDto";

class CustomerApiCredentialListDto {
    Id: number;
    CreatedBy: UserDto;
    ValidityStart: Date;
    ValidityEnd: Date | null;
    Name: string;
    Type: number;

    TypeLabel: string;

    constructor(id: number, createdBy: UserDto, validityStart: Date, validityEnd: Date | null, name: string, type: number) {
        this.Id = id;
        this.CreatedBy = createdBy;
        this.ValidityStart = validityStart;
        this.ValidityEnd = validityEnd;
        this.Name = name;
        this.Type = type;

        this.TypeLabel = "???";
        switch (type) {
            case 1: this.TypeLabel = "Personal access token"; break;
            case 2: this.TypeLabel = "OAuth 2.0"; break;
        }
    }
}

export default CustomerApiCredentialListDto;
